// extracted by mini-css-extract-plugin
export default {"main":"Account_main__v6+uc","aside":"Account_aside__68g59","article":"Account_article__ilbDJ"};